//TODO: this file probably doesn't need to exist, since the default values for each field (with no exception) is simply based on its type. 

export default {
  status_history: [],
  theme: 'default',
  idp_record_id: '',
  basic_info: {
    floorplan_upload: '',
    virtual_tour_link: '',
    white_box_link: '',
    actual_sq_ft: '',
    overall_actual_sq_ft: '',
    client_provided_sq_ft: '',
    joist_direction: '',
    has_stepdown_transformer: false,
    tear_sheet: false,
    size: '',
    mezannine_area: '',
    year_built: '',
    site_size: '',
    tax_pin: '',
    zoning: '',
    measured_width_of_space: '',
    measured_depth_of_space: '',
    total_depth_of_space: '',
    lockbox_used_to_access_the_space: false,
    exterior_ladder_used_to_access_the_roof: false,
    roof_too_unsafe_to_access: false,
    roof_hatch_used_to_access_the_roof: false,
    misc_notes: '',
    electric_meter_distance: '',
    gas_meter_distance: '',
    water_meter_distance: '',
    transformer_distance: '',
    sewer_cleanout_distance: '',
    utility_room_distance: '',
    DMARC_distance: '',
    phone_board_location: '',
    phone_board_count: '',
    sanitary_sewer_count: '',
    sanitary_sewer_location: '',
    cleanout_location: '',
    cleanout_count: '',
    pad_mounted_transformer_location: '',
    pad_mounted_transformer_count: '',
    mop_sink_location: '',
    mop_sink_count: '',
    thermostat_location: '',
    thermostat_count: '',
    cooler_manufacturer: '',
    storefront_slope_measurement: '',
    storefront_slope_direction: '',
    are_demising_walls_full_height: false,
    are_interior_walls_full_height: false,
    changes_in_demising_wall_thickness: false,
    difference_demising_wall_thickness: '',
    which_demising_wall_changes: '',
    hazardous_materials: false,
    loading_dock: false,
    exterior_wall_photograph: false,
    storefront_scan_width: false,
    roof_capture_hvac: false,
    roof_plan_complete: false,
    projector_photograph: false,
    window_pane_type: '',
    riser_room_scanned_captured: false,
    outer_unit_corner_to_outer_block_corner: {
      left: '',
      right: ''
    },
    height_from_floor_to_bottom_of_girder_kite: {
      left_front: '',
      right_rear: ''
    },
    thickness: {
      front_wall: '',
      rear_wall: '',
      left_wall: '',
      right_wall: ''
    },
    unit_overview: {
      sales_area: '',
      stock_room: '',
      exterior_doors: '',
      other: ''
    },
    integrations: {
      integration_property_id: '',
      idp_record_id: ''
    },
    flooring_square_footage: {
      concrete: '',
      tile: '',
      other: '',
      carpet: '',
      total: '',
      unit: '',
      type_of_other: ''
    },
    ceiling_information: {
      height_from_floor_to_ceiling: {
        front: '',
        back: '',
        center: ''
      },
      height_from_floor_to_bottom_of_deck: {
        front: '',
        back: '',
        center: ''
      },
      height_from_floor_to_bottom_of_joist: {
        front: '',
        back: '',
        center: ''
      },
      clear_height: '',
      height_from_floor_to_bottom_of_girder: {
        left_front: '',
        left_rear: '',
        right_front: '',
        right_rear: '',
        middle: ''
      },
      clear_ceiling_height: '',
      number_of_acoustical_tiles: '',
      clear_height_floor_to_deck: '',
      clear_height_floor_front_column: '',
      clear_height_floor_mid_column: '',
      clear_height_floor_rear_column: '',
      clear_height_floor_to_lowest_obstruction: ''
    },
    construction_overview: {
      structure: '',
      roof_type: '',
      roof_warranty_expiration: '',
      sprinkler_system: '',
      sprinkler_head_type: '',
      warehouse_lighting_type: '',
      warehouse_sprinkler_head_type: '',
      office_sprinkler_head_type: '',
      office_lighting_type: ''
    },
    property_features: {
      building_dimensions: '',
      space_dimensions_width: '',
      space_dimensions_length: '',
      column_bay_spacing: '',
      column_bay_spacing_depth: '',
      speed_bays: '',
      truck_court_depth: '',
      truck_apron: '',
      loading: '',
      floor_load: '',
      num_of_trailer_parking_spots: '',
      dock_doors: '',
      drive_in_doors: '',
      railway_dock_doors: '',
      car_parking: '',
      hvac: '',
      utility_submetered: '',
      power: '',
      interior_dock_leveler_type: '',
      interior_dock_leveler_width: '',
      interior_dock_leveler_height: '',
      dock_leveler_length: '',
      storefront_width: '',
      storefront_features: '',
      damaged_stained_missing_acoustical_tiles: '',
      ceiling_types: '',
      wall_types: '',
      exterior_door_count: '',
      exterior_door_dimensions: '',
      exterior_door_locations: '',
      light_fixture_count: '',
      type_of_lighting: '',
      type_of_fixture: '',
      access_interior_area: false,
      floor_drain_count: '',
      floor_drain_location: '',
      exterior_transformer: false,
      meter_room_space: false,
      exterior_access_rooms: false,
      exterior_partition_extrusion: false,
      hydraulic_sprinkler: false
    }
  }
};

/**
 * Used to set default values on space profile objects (mapped to Dynamo), so that inputs do not fluctuate between controlled and uncontrolled
 * @param {Object} defaults defaults to be set on a space profile object
 * @param {Object} data space profile data
 */
const setDefaults = (defaults, data) => {
  let keys = Object.keys(defaults);
  keys.forEach(key => {
    if (data[key] !== null && typeof data[key] === 'object') return setDefaults(defaults[key], data[key]);
    if (!data[key] && data[key] !== 0) data[key] = JSON.parse(JSON.stringify(defaults[key]));
  });
};

export { setDefaults };
